import React from "react";
import { Col, Tooltip, Typography } from "antd";

const { Text } = Typography;

const Language = ({
  span,
  title,
  active,
  disabled,
  language,
  languageName,
  onLanguageClick,
}) => (
  <Col span={span || 24} className="center">
    <Tooltip title={title}>
      <Text
        strong={active}
        disabled={disabled}
        onClick={() => !disabled && onLanguageClick(language)}
        className={`pointer language-text${active ? " language-active" : ""}`}
      >
        {languageName}
      </Text>
    </Tooltip>
  </Col>
);

export default Language;
